import { MpCheckbox } from './Checkbox'
export default MpCheckbox

export { skeletonCheckbox } from './checkbox-skeleton';

export { MpCheckbox, MpCheckboxProps } from './Checkbox'

